export default {
    SET_TOOLTIP_DATA_LOADING:"SET_TOOLTIP_DATA_LOADING",
    SET_TOOLTIP_DATA_SUCCESS:"SET_TOOLTIP_DATA_SUCCESS",
    SET_TOOLTIP_DATA_ERROR:"SET_TOOLTIP_DATA_ERROR",
    SET_INITIAL_TOOLTIP:"SET_INITIAL_TOOLTIP"
}